module.exports = __webpack_public_path__ + "img/zahnarztpraxis_1.b11e9a45.jpg";